import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiPlus, FiHome, FiUsers, FiSettings } = FiIcons;

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      title: 'Add Property',
      description: 'Create a new rental property',
      icon: FiHome,
      color: 'blue',
      onClick: () => navigate('/properties')
    },
    {
      title: 'Create Guest Page',
      description: 'Generate a new guest portal',
      icon: FiUsers,
      color: 'green',
      onClick: () => navigate('/guest-pages')
    },
    {
      title: 'Automation Settings',
      description: 'Configure automatic workflows',
      icon: FiSettings,
      color: 'purple',
      onClick: () => navigate('/automation')
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      className="bg-white rounded-xl shadow-sm p-6 border border-gray-100"
    >
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
      
      <div className="space-y-3">
        {actions.map((action, index) => (
          <motion.button
            key={index}
            onClick={action.onClick}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="w-full flex items-center space-x-3 p-4 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          >
            <div className={`p-2 rounded-lg ${
              action.color === 'blue' ? 'bg-blue-100 text-blue-600' :
              action.color === 'green' ? 'bg-green-100 text-green-600' :
              'bg-purple-100 text-purple-600'
            }`}>
              <SafeIcon icon={action.icon} className="text-lg" />
            </div>
            <div className="flex-1 text-left">
              <p className="font-medium text-gray-900">{action.title}</p>
              <p className="text-sm text-gray-500">{action.description}</p>
            </div>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default QuickActions;